import { render, staticRenderFns } from "./DeleteMaterial.vue?vue&type=template&id=cb7f9996&scoped=true"
import script from "./DeleteMaterial.vue?vue&type=script&lang=js"
export * from "./DeleteMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f9996",
  null
  
)

export default component.exports